import { _ctmUserInfoApi } from "@/plugins/ctmUserInfoAxios";

// const getCtmUserInfo = (params) => {
//   if (params.type === "mobile") {
//     return _ctmUserInfoApi.get(
//       `/external/sugang/getSugangInfo?type=mobile&mobile=${params.mobile}&name=${params.name}&companyIdx=${params.code}`
//     );
//   } else {
//     return _ctmUserInfoApi.get(
//       `/external/sugang/getSugangInfo?type=email&email=${params.email}&companyIdx=${params.code}`
//     );
//   }
// };

const getCtmUserInfo = (params) => {
  if (params.type === "mobile") {
    return _ctmUserInfoApi.get(
      `/external/sugang/getSugangHistoryList?type=mobile&mobile=${params.mobile}&name=${params.name}&companyIdx=${params.code}`
    );
  } else {
    return _ctmUserInfoApi.get(
      `/external/sugang/getSugangHistoryList?type=email&email=${params.email}&companyIdx=${params.code}`
    );
  }
};

export { getCtmUserInfo };
